<template>
    <tr class="fs-tree">
        <th
            class="ellipsis"
            :class="{highlight: activeRow===index}"
            :style="`padding-left:${ (node.level * 1) + .5 }em`"
            @click.ctrl="toggleLang"
        >
            {{ label }}
            <div class="resizer"></div>
        </th>
        <template v-if="activeBSheet">
            <fs-cell
                ref="cell"
                v-for="(fs,idx) in activeBSheet"
                class="fs-item"
                :class="{
                    unsatisfied: fs.unsatisfied.filter(e => e.concept===node.id).length,
                }"
                :unsatisfiedMessages="fs.unsatisfied.filter(e => e.concept===node.id).reduce((a,m) => m, {})"
                tabindex="-1"
                v-model="fs.lineItems[node.id]"
                :key="idx"
                :abstract="node.abstract"
                :summation="node.summationItem"
                :calculated="node.calculated"
                :role="node.abstract? false : 'grid-cell'"
                :index="idx"
                :node="fs"
            />
                <!--:slot="fs.lineItems[node.id]|formatNumber"-->
        </template>
    </tr>
</template>

<script>
import FsCell from './FsCell.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'fs-tree',
    props: ['node', 'lang', 'highlight', 'index'],
    computed: {
        label() {
            let lang = this.$store.state.lang
            let prefLabel = this.node.preferredLabel
            return this.node.labels.filter(l => l.role==prefLabel && l.lang==lang).reduce(x => x).label
        },
        ...mapGetters(['activeBSheet','activeRow']),
    },
    methods: {
        toggleLang: function() {
            this.$store.dispatch('toggleLang')
        }
    },
    components: {
        FsCell
    },
    mounted() {

    }
}
</script>

<style>
.fs-grid td {
    min-width: 10em;
    border: solid 1px #ccc;
}
.highlight {
    background: lightgoldenrodyellow;
}
.ellipsis {
    height: 23px;
    max-width:30em;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
}
tbody th {
    position: relative;
}
.resizer {
    position: absolute;
    top: 0;
    right: 0;
    content: " ";
    width: 4px;
    height: 100%;
    z-index: 1;
    cursor: ew-resize;
}
/* .resizer:hover {
    background: rgba(103, 136, 173, 0.6);
} */
.unsatisfied {
    background: rgb(223, 140, 140);
}
</style>